import { OuiSelectOption } from 'omnium-ui/form-field';
import { Observable } from 'rxjs';
import { inNotInOperator, fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getLevierInvestisseursBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_CAPACITE_REMBOURSEMENT_EMPRUNT_RESTANT_MENSUELLE',
      'syntheseFinanciere.capaciteRemboursementRestanteMensuelInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_CAPACITE_EPARGNE_MENSUELLE',
      'syntheseFinanciere.capaciteEpargneMensuelleInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_EFFORT_EPARGNE_MENSUEL',
      'syntheseFinanciere.effortEpargneInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_EPARGNE_PRECAUTION_REELLE',
      'syntheseFinanciere.epargnePrecautionReelleInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),

    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_EPARGNE_PRECAUTION_SOUHAITEE',
      'syntheseFinanciere.epargnePrecautionSouhaiteeInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_EPARGNE_DISPONIBLE',
      'syntheseFinanciere.epargneDisponibleInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_MENSUALITE_CREDIT_TOTALE',
      'syntheseFinanciere.mensualiteCreditTotaleInvestisseur',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_INVESTISSEUR',
      'LEVIER_INV_TAUX_ENDETTEMENT',
      'syntheseFinanciere.tauxEndettementInvestisseur',
      fullComparator,
      'InputPercent',
      undefined,
      3
    ),
  ];
}

export function getLevierCoupleBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_CAPACITE_REMBOURSEMENT_EMPRUNT_RESTANT_MENSUELLE',
      'syntheseFinanciere.capaciteRemboursementRestanteMensuelCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_CAPACITE_EPARGNE_MENSUELLE',
      'syntheseFinanciere.capaciteEpargneMensuelleCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_EFFORT_EPARGNE_MENSUEL',
      'syntheseFinanciere.effortEpargneCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_EPARGNE_PRECAUTION_REELLE',
      'syntheseFinanciere.epargnePrecautionReelleCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),

    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_EPARGNE_PRECAUTION_SOUHAITEE',
      'syntheseFinanciere.epargnePrecautionSouhaiteeCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_EPARGNE_DISPONIBLE',
      'syntheseFinanciere.epargneDisponibleCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_MENSUALITE_CREDIT_TOTALE',
      'syntheseFinanciere.mensualiteCreditTotaleCouple',
      fullComparator,
      'InputEuro',
      undefined,
      12
    ),
    new ItemFiltreCustomBuilder(
      'LEVIER_COUPLE',
      'LEVIER_COUPLE_TAUX_ENDETTEMENT',
      'syntheseFinanciere.tauxEndettementCouple',
      fullComparator,
      'InputPercent',
      undefined,
      3
    ),
  ];
}
